import * as firebase from 'firebase/app'
import 'firebase/performance'
import 'firebase/analytics'
import 'firebase/messaging'

export default firebase
